
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/calendar/calendar-listing",
      function () {
        return require("private-next-pages/profile/calendar/calendar-listing/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/calendar/calendar-listing"])
      });
    }
  